export const GOAL_OF_MONTH_PATHS = {
    GOAL_OF_MONTH: {
        path: '/golmesiaca',
        name: 'goal-of-month:lobby'
    }
} as const;
